<router-outlet *ngIf="loaded"></router-outlet>
<app-spinner></app-spinner>
